import { IClassname } from '@/lib/shared/model/classname';

export const Gazebo = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12H8V27H24V12Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 23V27H8V23"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21H4V27H13"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21H28V27H19"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8207 11.9231C27.8207 9.36724 18.6197 4 16.0638 4C13.508 4 4.1792 9.36724 4.1792 11.9231H27.8207Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4443 27.0025V18.3127C13.4443 16.907 14.5945 15.7568 16.0002 15.7568C17.4059 15.7568 18.556 16.907 18.556 18.3127V27.0025"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
